import { ServiceBase } from '../../../../core/services/ServiceBase'
import peerAnalysisProxy from './peerAnalysisProxy'

class PeerAnalysisService extends ServiceBase {
  getOwnershipAndGroup(params) {
    return this.getData(() => peerAnalysisProxy.getOwnershipAndGroup(params))
  }

  getFinancialStatements(params) {
    return this.getData(() => peerAnalysisProxy.getFinancialStatements(params))
  }

  getFinancialAnalysis(params) {
    return this.getData(() => peerAnalysisProxy.getFinancialAnalysis(params))
  }

  getScore(params) {
    return this.getData(() => peerAnalysisProxy.getScore(params))
  }

  getYearReports(params) {
    return this.getData(() => peerAnalysisProxy.getYearReports(params))
  }

  getSavedPortfolio(params) {
    return this.getData(() => peerAnalysisProxy.getSavedPortfolio(params))
  }

  getRecommendationPortfolio(params) {
    return this.getData(() =>
      peerAnalysisProxy.getRecommendationPortfolio(params),
    )
  }

  getRecommendationRevenue(params) {
    return this.getData(() =>
      peerAnalysisProxy.getRecommendationRevenue(params),
    )
  }

  getRecommendationYearsOfOperation(params) {
    return this.getData(() =>
      peerAnalysisProxy.getRecommendationYearsOfOperation(params),
    )
  }
  postMoveOrCopyCompany(params) {
    return this.getData(() => peerAnalysisProxy.postMoveOrCopyCompany(params))
  }
}

export default new PeerAnalysisService()
